import axios from "axios";
/**
 * 请求外部账号的公用方法
 * @param {string} sources - 数据来源，例如 "回收宝"
 * @returns {Promise<any>} - 返回请求结果的 Promise
 */
export const getExtraAccount = async (sources) => {
    try {
        // const response = await axios.get("/api/buy-ease/externalAccount/queryOrderExternalAccount", {
        const response = await axios.get("/api/externalAccount/queryOrderExternalAccount", {
            params: {
                sources: sources,
            },
            headers: {
                satoken: localStorage.getItem("sa") || "",
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("请求外部账号失败：", error);
        throw error;
    }
};
/**
 * 出价下单的公用方法
 * @param {Object} jsonData - 下单所需的参数对象
 * @param {string} jsonData.accountId - 下单账号 ID
 * @param {number} jsonData.amount - 数量
 * @param {string} jsonData.stickCode - 商品编码
 * @param {string} jsonData.patch - 批次号
 * @param {string} jsonData.infoId - 信息 ID
 * @returns {Promise<any>} - 返回请求结果的 Promise
 */
export const doPurchase = async (jsonData) => {
    try {
        const response = await axios.post("/api/orderDetails/add", jsonData, // 直接传递 JSON 数据
        {
            headers: {
                satoken: localStorage.getItem("sa") || "",
                "Content-Type": "application/json",
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("请求下单失败：", error);
        throw error;
    }
};
/**
 * 获取外部账号的公用方法
 * @param {string} jsonData.patch  - 批次号
 * @param {string} jsonData.accountId - 下单账号 ID
 * @param {string} jsonData.stickCode - 商品编码
 * @returns {Promise<any>} - 返回请求结果的 Promise
 */
export const getPurchaseResult = async (jsonData) => {
    try {
        const response = await axios.get("/api/orderDetails/currentOrderList", {
            params: {
                ...jsonData,
            },
            headers: {
                satoken: localStorage.getItem("sa") || "",
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("请求下单结果失败：", error);
        throw error;
    }
};
